import { useCartStore } from '../../store/useCartStore';
import { hasAnyDiscount } from '../../utils/cart/discountCalculations';
import type { DiscountApplication } from '../../types/cartTypes';

/**
 * 折扣汇总信息及操作方法
 */
export interface DiscountSummary {
    /** 总折扣金额 (分) */
    totalDiscountCents: number;
    /** 折扣应用列表 */
    discounts: DiscountApplication[];
    /** 是否有任何折扣应用 */
    hasDiscount: boolean;
    /** 购物车货币代码 */
    currency: string;
    /** 当前输入的折扣码状态 */
    discountCode: {
        /** 优惠码文本 */
        code: string | null;
        /** 已应用折扣码列表 */
        appliedCodes: string[];
        /** 是否已通过验证 */
        isValid: boolean;
    /** 是否正在验证中 */
    isValidating: boolean;
    };
}


/**
 * useDiscountSummary - 折扣汇总 Hook
 * 
 * 职责：
 * - 从 Store 读取折扣数据（权威来源）
 * - 提供动作函数（removeDiscountCode/applyDiscountCode）给 UI
 * - UI 不直接引用 Service，通过此 Hook 提供的回调调用
 */
export function useDiscountSummary(): DiscountSummary {
    const totalDiscountCents = useCartStore((state) => state.total_discount);
    const discounts = useCartStore((state) => state.cart_level_discount_applications || []);
    const currency = useCartStore((state) => state.currency);
    const discountCode = useCartStore((state) => state.discountCode);
    return {
        totalDiscountCents,
        discounts,
        hasDiscount: hasAnyDiscount(totalDiscountCents),
        currency,
        discountCode: {
            code: discountCode.code,
            appliedCodes: discountCode.appliedCodes,
            isValid: discountCode.isValid,
            isValidating: discountCode.isValidating
        }
    };
}
